import { useContext } from 'react';
import type Bowser from 'bowser';
import DeviceContext from '../state/DeviceContext';

/**
 * Isomorphic hook that exposes information about users current device.
 *
 * @see https://github.com/lancedikson/bowser
 */
const useDevice = (): Bowser.Parser.ParsedResult | null => {
  const parser = useContext(DeviceContext);

  if (!parser) {
    return null;
  }

  return parser.getResult();
};

export default useDevice;
